/**
 * DraftPair applier.
 *
 * Takes the (tile, wildlife) from market.slots[action.slot] into the active
 * player's draft, empties that slot, and advances phase: marketCheck → placeTile.
 *
 * Spec §6.3.
 */

import type { DraftPairAction } from "../types/actions";
import type { GameState } from "../types/game-state";
import type { MarketSlot } from "../types/market";
import { bumpVersion } from "./common-applier";

export const applyDraftPair = (
  state: GameState,
  action: DraftPairAction,
): GameState => {
  const slot = state.market.slots[action.slot];
  const draftedTile = slot.tileInstanceId;
  const draftedToken = slot.tokenInstanceId;

  const newSlots = state.market.slots.map((s) =>
    s.index === action.slot
      ? ({
          ...s,
          tileInstanceId: null,
          tokenInstanceId: null,
          tileDefId: null,
          wildlifeSpecies: null,
        } satisfies MarketSlot)
      : s,
  ) as [MarketSlot, MarketSlot, MarketSlot, MarketSlot];

  const activeSeat = state.turn.activeSeat;

  return {
    ...state,
    ...bumpVersion(state),
    market: {
      ...state.market,
      slots: newSlots,
    },
    turn: {
      ...state.turn,
      phase: "placeTile",
    },
    players: state.players.map((p) =>
      p.seat === activeSeat
        ? {
            ...p,
            draft: {
              tileInstanceId: draftedTile,
              tokenInstanceId: draftedToken,
            },
          }
        : p,
    ),
  };
};
